import { useState } from "react";
import { useAuth } from "react-oidc-context";
import DropdownMenu from "./DropdownMenu";

const Admin = () => {
  const auth = useAuth();
  const validFileNames = ['Indices.csv','Options.csv','Segments.csv'];
  const [selectedFilename,setSelectedFilename] = useState("");
  const [uploadStatus,setUploadStatus] = useState(null);
  const [uploadErrorMessage,setUploadErrorMessage] = useState(null);
  const [uploadValidationErrors,setUploadValidationErrors] = useState([]);
  const [downloadStatus,setDownloadStatus] = useState(null);
  const [downloadErrorMessage,setDownloadErrorMessage] = useState(null);
  const [downloadUrl,setDownloadUrl] = useState(null);

  const onUpload = (e) => {
    const file = e.target.files?.[0] || null;

    if (file && file.type === "text/csv" && validFileNames.includes(file.name)) {
      fetch(`https://${process.env.REACT_APP_API_DOMAIN}/file-handler/push/${file.name}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${auth.user?.access_token}`
        },
        body: file
      }).then(res => {
        return res.json();
      }).then(resJson => {
        setUploadStatus(resJson.status)
        setUploadErrorMessage(resJson.errorMessage);
        setUploadValidationErrors(resJson.validationErrors ? resJson.validationErrors.split('|') : []);
      }).catch(err => {
        setUploadStatus("Failed");
        setUploadErrorMessage("Please contact technical support or try again later");
        setUploadValidationErrors([]);
      });
    } else if (file && (file.type !== "text/csv" || !validFileNames.includes(file.name))) {
      setUploadStatus("Failed");
      setUploadErrorMessage("File must be either Indices.csv, Options.csv, or Segments.csv");
      setUploadValidationErrors([]);
    } else {
      setUploadStatus(null);
      setUploadErrorMessage(null);
      setUploadValidationErrors([]);
    }
  };

  const onDownload = (filename) => {
    setSelectedFilename(filename);
    if (filename !== "") {
      fetch(`https://${process.env.REACT_APP_API_DOMAIN}/file-handler/pull/${filename}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${auth.user?.access_token}`
          }
        }).then(res => {
          return res.json();
        }).then(resJson => {
          setDownloadStatus(resJson.status);
          setDownloadErrorMessage(resJson.errorMessage);
          setDownloadUrl(resJson.fileContent ? 
            URL.createObjectURL(new Blob([resJson.fileContent], { type: "text/csv;charset=utf-8;" })) : null);
        }).catch(err => {
          setDownloadStatus("Failed");
          setDownloadErrorMessage("Please contact technical support or try again later");
          setDownloadUrl(null);
        });
    } else {
      setDownloadStatus(null);
      setDownloadErrorMessage(null);
      setDownloadUrl(null);
    }
  };
  
  return (
    <div className="row" style={{ marginTop: '20px' }}>
      <div className="col s12 l6">
        <h6><b>Download latest configuration</b></h6>
        <DropdownMenu filterValue={selectedFilename} options={validFileNames} onSelect={onDownload}/>
        {downloadStatus && 
          <h5><b>Download Status: <span className={downloadStatus === 'Success' ? 'green-text' : 'red-text'}>{downloadStatus}</span></b></h5>}
        {downloadErrorMessage && <h6><b>{downloadErrorMessage}</b></h6>}
        {downloadUrl && (<a className="btn waves-effect waves-light blue" href={downloadUrl} download={selectedFilename}>
          <i className="material-icons left">file_download</i>
          Download
        </a>)}
      </div>
      <div className="col s12 l6">
        <h6><b>Upload new configuration</b></h6>
        <div className="file-field input-field">
          <div className="btn waves-effect waves-light blue">
            <span><i className="material-icons left">file_upload</i>Upload File</span>
            <input type="file" id="fileInput" onChange={onUpload}/>
          </div>
          <div className="file-path-wrapper">
            <input className="file-path" type="text" placeholder="Choose a file..." readOnly/>
          </div>
        </div>
        {uploadStatus && 
          <h5><b>Upload Status: <span className={uploadStatus === 'Success' ? 'green-text' : 'red-text'}>{uploadStatus}</span></b></h5>}
        {uploadErrorMessage && <h6><b>{uploadErrorMessage}</b></h6>}
        {uploadValidationErrors.length > 0 && (
          <ul className="browser-default">
            {uploadValidationErrors.map((error, index) => (
              <li key={index}>
                {error}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Admin;